import { apiClient } from './client';

// Types for connections API
export interface Connection {
  id: string;
  platformName: string;
  platformType: string;
  iconUrl?: string;
  settings?: any;
}

/**
 * Connections API client
 */
export const connectionsApi = {
  /**
   * Get all connections for the current user
   * @returns Array of connections
   */
  getAll: async (): Promise<Connection[]> => {
    const { data } = await apiClient.get<Connection[]>('/api/connections');
    return data || [];
  },

  /**
   * Get active connections for the current user
   * @returns Array of active connections
   */
  getActive: async (): Promise<Connection[]> => {
    const { data } = await apiClient.get<Connection[]>('/api/connections');
    return data || [];
  },

  /**
   * Create a new connection
   * @param connectionData The connection data
   * @returns The created connection
   */
  create: async (connectionData: any): Promise<Connection> => {
    const { data } = await apiClient.post<Connection>('/api/connections', connectionData);
    return data;
  },

  /**
   * Update an existing connection
   * @param connectionId The ID of the connection to update
   * @param updates The updates to apply
   * @returns The updated connection
   */
  update: async (connectionId: string, updates: any): Promise<Connection> => {
    const { data } = await apiClient.put<Connection>(`/api/connections/${connectionId}`, updates);
    return data;
  },

  /**
   * Delete a connection
   * @param connectionId The ID of the connection to delete
   */
  delete: async (connectionId: string): Promise<void> => {
    await apiClient.delete(`/api/connections/${connectionId}`);
  },
};
